import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import TransactionsPage from "@/pages/TransactionsPage";
import Accounts from "@/pages/Accounts";
import Contacts from "@/pages/Contacts";
import Upcoming from "@/pages/Upcoming";
import Cheques from "@/pages/Cheques";
import ChequeBooks from "@/pages/ChequeBooks";
import Employees from "@/pages/Employees";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Shipping from "@/pages/Shipping";
import Loans from "@/pages/Loans";
import CreditCards from "@/pages/CreditCards";
import Invoices from "@/pages/Invoices";
import InvoiceImports from "@/pages/InvoiceImports";
import Guarantees from "@/pages/Guarantees";
import Todos from "@/pages/Todos";
import Budgets from "@/pages/Budgets";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import Stocks from "@/pages/Stocks";
import SupplierOrders from "@/pages/SupplierOrders";
import Quotes from "@/pages/Quotes";
import HelpDocs from "@/pages/HelpDocs";

// pricing_only rolündeki kullanıcı için erişilebilir rota beyaz listesi
const PRICING_ONLY_PATHS = new Set(["/fiyatlandirma"]);

function LandingRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center label-caps">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "pricing_only" ? "/fiyatlandirma" : "/dashboard"} replace />;
}

function Protected({ children, path }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center label-caps">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "pricing_only" && !PRICING_ONLY_PATHS.has(path)) {
    return <Navigate to="/fiyatlandirma" replace />;
  }
  return <AppShell>{children}</AppShell>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<LandingRedirect />} />
      <Route path="/dashboard" element={<Protected path="/dashboard"><Dashboard /></Protected>} />
      <Route path="/gelirler" element={<Protected path="/gelirler"><TransactionsPage type="income" title="Gelirler" /></Protected>} />
      <Route path="/giderler" element={<Protected path="/giderler"><TransactionsPage type="expense" title="Giderler" /></Protected>} />
      <Route path="/hesaplar" element={<Protected path="/hesaplar"><Accounts /></Protected>} />
      <Route path="/cari" element={<Protected path="/cari"><Contacts /></Protected>} />
      <Route path="/faturalar" element={<Protected path="/faturalar"><Invoices /></Protected>} />
      <Route path="/fatura-ice-aktar" element={<Protected path="/fatura-ice-aktar"><InvoiceImports /></Protected>} />
      <Route path="/yaklasan" element={<Protected path="/yaklasan"><Upcoming /></Protected>} />
      <Route path="/cekler" element={<Protected path="/cekler"><Cheques /></Protected>} />
      <Route path="/cek-kocanlari" element={<Protected path="/cek-kocanlari"><ChequeBooks /></Protected>} />
      <Route path="/personel" element={<Protected path="/personel"><Employees /></Protected>} />
      <Route path="/personel/:id" element={<Protected path="/personel/:id"><EmployeeDetail /></Protected>} />
      <Route path="/nakliye" element={<Protected path="/nakliye"><Shipping /></Protected>} />
      <Route path="/krediler" element={<Protected path="/krediler"><Loans /></Protected>} />
      <Route path="/kredi-kartlari" element={<Protected path="/kredi-kartlari"><CreditCards /></Protected>} />
      <Route path="/teminat-mektuplari" element={<Protected path="/teminat-mektuplari"><Guarantees /></Protected>} />
      <Route path="/yapilacaklar" element={<Protected path="/yapilacaklar"><Todos /></Protected>} />
      <Route path="/butceler" element={<Protected path="/butceler"><Budgets /></Protected>} />
      <Route path="/raporlar" element={<Protected path="/raporlar"><Reports /></Protected>} />
      <Route path="/fiyatlandirma" element={<Protected path="/fiyatlandirma"><Pricing /></Protected>} />
      <Route path="/teklifler" element={<Protected path="/teklifler"><Quotes /></Protected>} />
      <Route path="/tedarikci-siparisleri" element={<Protected path="/tedarikci-siparisleri"><SupplierOrders /></Protected>} />
      <Route path="/stok" element={<Protected path="/stok"><Stocks /></Protected>} />
      <Route path="/ayarlar" element={<Protected path="/ayarlar"><Settings /></Protected>} />
      <Route path="/dokuman" element={<Protected path="/dokuman"><HelpDocs /></Protected>} />
      <Route path="*" element={<LandingRedirect />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
